module.exports = __webpack_public_path__ + "static/media/buffet4.a4f935b0.jpg";